import { createContext, useContext, useEffect, useState } from 'react'
import { companyApi } from '../services/api'

const CompanyContext = createContext(null)

export function CompanyProvider({ children }) {
    const [company, setCompany] = useState({
        companyName: '',
        addressLine1: '',
        addressLine2: '',
        phone: '',
        fax: '',
        website: '',
        hasLeftLogo: false,
        hasRightLogo: false,
    })

    useEffect(() => {
        loadCompanySettings()
    }, [])

    async function loadCompanySettings() {
        try {
            const response = await companyApi.getSettings()
            if (response.success) {
                const s = response.settings
                setCompany(s)

                // Set browser tab title
                if (s.companyName) {
                    document.title = `${s.companyName} Timesheets`
                }

                // Set favicon from left logo if it exists
                if (s.hasLeftLogo) {
                    const favicon = document.querySelector("link[rel='icon']")
                        || document.createElement('link')
                    favicon.rel = 'icon'
                    favicon.href = `/api/company-settings/logo/left?t=${Date.now()}`
                    document.head.appendChild(favicon)
                }
            }
        } catch (error) {
            console.error('Failed to load company settings:', error)
        }
    }

    function refreshSettings() {
        loadCompanySettings()
    }

    return (
        <CompanyContext.Provider value={{ company, refreshSettings }}>
            {children}
        </CompanyContext.Provider>
    )
}

export function useCompany() {
    return useContext(CompanyContext)
}